import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GrammatechCodeSentryMappingForm from './GrammatechCodeSentryMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function GrammatechCodeSentryCredentialForm(props, ref) {
    const fields = useMemo(() => {
        return [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator]
        }, {
            name: "httpauth-username",
            label: "Auth UserName",
            required: true,
        }, {
            name: "httpauth-password",
            label: "Auth Password",
            type: FieldTypes.PASSWORD,
            required: true
        }, {
            name: "username",
            label: "Username",
            required: true,
        }, {
            name: "password",
            label: "Password",
            type: FieldTypes.PASSWORD,
            required: true
        }, {
            name: "client_id",
            label: "Client Id",
            required: true
        },
         {
            name: "client_secret",
            label: "Client Secret",
            required: true,
            type: FieldTypes.PASSWORD
        }]
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={GrammatechCodeSentryMappingForm}
        />
    )
}

export default forwardRef(GrammatechCodeSentryCredentialForm);